var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    { staticClass: "post members" },
    [
      _c(
        "d-main-image",
        _vm._b(
          { on: { load: _vm.pageLoaded } },
          "d-main-image",
          { img: _vm.img, show: _vm.show },
          false
        )
      ),
      _c("w-go-down"),
      _c("k-main", { attrs: { title: _vm.title } }, [
        _c("section", {
          staticClass: "description",
          domProps: { innerHTML: _vm._s(_vm.content) },
        }),
        _c(
          "section",
          { staticClass: "subscriptions" },
          [
            _vm.user &&
            (!_vm.user.as || _vm.user.as.subscriber) &&
            _vm.user.membership
              ? _c(
                  "subscription-menu",
                  { attrs: { target: _vm.postData.path } },
                  [_vm._v("Change your subscription plan below.")]
                )
              : _c(
                  "subscription-menu",
                  { attrs: { target: _vm.postData.path } },
                  [
                    _vm._v(
                      "Select one of the subscription plans to become a member."
                    ),
                  ]
                ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }